import { enterStagger } from "@/utils/motion";

export default {
  mounted(el, binding) {
    const targets = binding.modifiers.children ? el.children : [el];
    const delay = typeof binding.value === "number" ? binding.value : 0;
    enterStagger(targets, { delay });
  },
};
